import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevrons-right",
  "use": "chevrons-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"chevrons-right\">\n<path d=\"M13,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l4.3-4.3l-4.3-4.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5\n\tc0.4,0.4,0.4,1,0,1.4l-5,5C13.5,17.9,13.3,18,13,18z\" />\n<path d=\"M6,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L9.6,12L5.3,7.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5\n\tc0.4,0.4,0.4,1,0,1.4l-5,5C6.5,17.9,6.3,18,6,18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol